import { Box } from '@modusign/design-system';

interface SignatureIconProps {
  color?: string;
  size?: string | number;
}

export default function SignatureIcon({ color, size }: SignatureIconProps) {
  return (
    <Box
      as="svg"
      fill="none"
      sx={{ color, height: size, width: size }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="11" stroke="currentColor" strokeWidth="2" />
      <rect fill="currentColor" height="12" rx="6" width="12" x="6" y="6" />
    </Box>
  );
}
